<div *ngFor="let noteSection of noteSections">
  <div [ngClass]="noteSection.noteClass" class="info-panel mt-10 mb-10" role="alert">
    <i [ngClass]="noteSection.iconClass || ''" class="redWarningIcon"></i>
    <strong> {{ noteSection.title }}</strong>
    <div class="ms-20">
      <span [innerHTML]="noteSection.body | mdToHtml"></span>
    </div>
  </div>
</div>
